export default "__VITE_ASSET__DurIw7_j__"